module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('form', {
    class: _vm.getFormClass,
    attrs: {
      "novalidate": "novalidate",
      "onsubmit": "return false;"
    }
  }, [_c('div', {
    class: _vm.getClassWrapper,
    attrs: {
      "role": "search"
    }
  }, [_c('input', {
    class: _vm.getClassInputPlaceholder,
    attrs: {
      "type": "search",
      "name": "search",
      "placeholder": _vm.getPlaceholder,
      "autocomplete": "off",
      "required": "required"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textVal),
      expression: "textVal"
    }],
    class: _vm.getClassInput,
    attrs: {
      "disabled": _vm.disabled,
      "type": "search",
      "name": _vm.name,
      "placeholder": "",
      "autocomplete": "off",
      "required": "required",
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm._s(_vm.textVal)
    },
    on: {
      "click": _vm.emitClickInput,
      "keyup": _vm.changeText,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: _vm.getClassSubmit,
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.emitClickButton
    }
  }, [_c('svg', {
    attrs: {
      "role": "img",
      "aria-label": "Search"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": _vm.getSVGSearch
    }
  })])]), _vm._v(" "), _c('button', {
    class: _vm.getClassReset,
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('svg', {
    attrs: {
      "role": "img",
      "aria-label": "Reset"
    }
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": _vm.getSVGClear
    }
  })])]), _vm._v(" "), (_vm.modeIsFull) ? _c('div', {
    staticClass: "el-input-group__append"
  }, [(_vm.suggestionsIsVisible && _vm.showSuggestions) ? _c('ul', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "vue-instant__suggestions"
  }, _vm._l((_vm.similiarData), function(item, index) {
    return _c('li', {
      class: _vm.getClassHighlighted(index),
      on: {
        "click": function($event) {
          _vm.selectedAction(index)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.suggestionAttribute]))])
  })) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('svg', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('symbol', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "sbx-icon-search-8",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 32c8.835 0 16-7.165 16-16 0-8.837-7.165-16-16-16C7.162 0 0 7.163 0 16c0 8.835 7.163 16 16 16zm0-5.76c5.654 0 10.24-4.586 10.24-10.24 0-5.656-4.586-10.24-10.24-10.24-5.656 0-10.24 4.584-10.24 10.24 0 5.654 4.584 10.24 10.24 10.24zM28.156 32.8c-1.282-1.282-1.278-3.363.002-4.643 1.282-1.284 3.365-1.28 4.642-.003l6.238 6.238c1.282 1.282 1.278 3.363-.002 4.643-1.283 1.283-3.366 1.28-4.643.002l-6.238-6.238z",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "sbx-icon-clear-4",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.664 9.877l4.485 4.485-1.542 1.54-4.485-4.485-4.485 4.485-1.54-1.54 4.485-4.485-4.485-4.485 1.54-1.54 4.485 4.484 4.485-4.485 1.54 1.542-4.484 4.485zM10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
      "fill-rule": "evenodd"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58b64930!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orch/can.vue
// module id = 262
// module chunks = 2